import { render } from "./DistributionPlotsSection.vue?vue&type=template&id=8f40fa8e"
import script from "./DistributionPlotsSection.vue?vue&type=script&lang=js"
export * from "./DistributionPlotsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__